/* eslint-disable no-console */

import Vue from 'vue'
import Router from 'vue-router'
import axios from 'axios';
import store from '@/store';
import Dashboard from './views/Dashboard.vue'
import Project from './views/Project.vue'
import ProjectNew from './views/ProjectNew.vue'
import ProjectEdit from './views/ProjectEdit.vue'
import Page from './views/Page.vue'
import Admin from './views/Admin.vue'
import Login from './views/Login.vue'
import Forgot from './views/Forgot.vue'
import NewPassword from './views/NewPassword.vue'
import Mobile from './views/Mobile.vue'
//import store from './store'

Vue.use(Router)

const router = new Router({
  mode:'history',
  routes: [
/*  {
    path: '/',
    name: 'loader',
    component: Loader,
    meta: {restricted:false},
  },
  */
    {
      path: '/',
      name: 'dashboard',
      component: Dashboard,
      meta: {restricted:true}, 
    },
    {
      path: '/mobile',
      name: 'mobile',
      component: Mobile,
      meta: {restricted:true}, 
    },
    {
      path: '/admin',
      name: 'admin',
      component: Admin,
      meta: {restricted:true}, 
    },
    {
      path: '/project/new',
      name: 'project-new',
      component: ProjectNew,
      props: false,
      meta: {restricted:true}, 
    },
    
    {
      path: '/project/:id',
      name: 'project',
      component: Project,
      props: true,
      meta: {restricted:true}, 
    },
    {
      path: '/project/:id/edit',
      name: 'project-edit',
      component: ProjectEdit,
      props: true,
      meta: {restricted:true}, 
    },
    {
      path: '/project/:id/:page_id',
      name: 'page',
      component: Page,
      props: true,
      meta: {restricted:true}, 
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      props: true,
      meta: {restricted:false}, 
    },
    {
      path: '/forgot',
      name: 'forgot',
      component: Forgot,
      props: true,
      meta: {restricted:false}, 
    },
    {
      path: '/new-password',
      name: 'new-password',
      component: NewPassword,
      props: true,
      meta: {restricted:false}, 
    },

  ]
})


router.beforeEach((to, from, next) => {
/*  window.scrollTo(0,0); */

  console.log('route beforeeach to: ',to.path);

  if(to.path=='/logout'){

    axios({
      method: 'get',
      url: '/api/logout',
    }).then((res)=>{
      store.dispatch('setUser',{})
    }).catch((error)=>{
      console.log('error',error);
    });

    return next('/login');
  }

  if(!store.getters.isAuthenticated && to.meta.restricted){
    store.dispatch('setIntendedUrl',to.path);
    return next('/login');
  }

  next();

});

export default router